import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

// config
import { ELEMENT_TYPE, THEME } from '../config/constants';
import Progress from '../helpers/imageCacheWithPreload';
import HeaderBraun from '../common/HeaderBraun';

import styles from './styles.module.css';

const LoadingScreen = ({ onComplete = () => {} }) => {
  const [complete, setComplete] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const preloadVideo = (resourcesPaths) => {
    if (typeof document !== `undefined`) {
      resourcesPaths.forEach((resourcePath) => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'video';
        link.crossOrigin = true;
        link.href = resourcePath;
        document.head.appendChild(link);
      });
    }
  };
  useEffect(() => {
    const preloadAllImages = () => {
      const commonDataTypes = [
        ELEMENT_TYPE.MOMENT,
        ELEMENT_TYPE.DESIGNER,
        ELEMENT_TYPE.PRODUCT,
      ];
      let imagesToPreload = [];

      // images from moments, designers, product
      commonDataTypes.forEach((dataType) => {
        const dataByType = require(`../data/${dataType}s`).default;

        Object.values(dataByType).forEach((dataElem) => {
          // get main images based on device
          imagesToPreload.push(
            isMobile ? dataElem?.imageMobile : dataElem?.imageLarge,
          );
          // get related
          dataElem.related.forEach((relatedElem) => {
            imagesToPreload.push(relatedElem.image);
          });
        });
      });

      // timeline images
      const timelineData = require(`../data/timeline`).default;

      timelineData.forEach((timelineElem) => {
        if (timelineElem.image) {
          imagesToPreload.push(timelineElem.image);
        }
        // product group
        if (timelineElem.products) {
          timelineElem.products.forEach((product) => {
            imagesToPreload.push(product.image);
          });
        }
        // discover
        if (timelineElem.elements) {
          timelineElem.elements.forEach((element) => {
            // get main images
            imagesToPreload.push(element.image);
          });
        }
      });

      // rooms
      const roomsData = require('../data/rooms').default;

      Object.values(roomsData).forEach((room) => {
        // get main images
        imagesToPreload.push(room.image);
        // get icons
        room.icons.forEach((iconElem) => {
          imagesToPreload.push(iconElem.icon);
        });
      });

      // make it unique
      imagesToPreload = Array.from(new Set(imagesToPreload));

      imagesToPreload.push(
        'https://res.cloudinary.com/arts/image/upload/b_rgb:000000,c_scale,w_672/v1599635869/max-braun/intro/Braun_100yrs.jpg',
      );

      const progress = Progress(
        (index, total) => {
          setComplete(Math.ceil((index * 100) / total));
        },
        () => {
          setIsLoading(false);
          onComplete();
        },
      );

      progress.loadImages(imagesToPreload);
    };

    preloadAllImages();
    preloadVideo([
      'https://res.cloudinary.com/arts/video/upload/v1600430502/max-braun/intro/Braun360_FullEdit_v021_2560x1440_H264_with_movcontainer_injected.mp4',
    ]);
  }, []);

  return (
    <>
      {isLoading && (
        <div className={styles.page}>
          <HeaderBraun theme={THEME.WHITE} />
          <div className={styles.container}>
            <div className={styles.start}>0</div>
            <div className={styles.progressBar}>
              <div
                className={styles.filler}
                style={{ width: `${complete}%` }}
              />
            </div>
            <div className={styles.stop}>{complete}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingScreen;

LoadingScreen.propTypes = {
  onComplete: PropTypes.func,
};
